<template>
  <div class="app-container">
    <div class="login">
      <h1>Let's Get Started</h1>
        <div class="button--submit" @click.prevent="redirectSignin"><span>Log in with</span> <IconGithub class="icon--github" aria-label="GitHub"></IconGithub></div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

import IconGithub from "./icons/IconGithub.vue";

const config = {
  apiKey: "AIzaSyC5GoO8Auu8WTKcpP0EHCIvmF0x6zbwTt4",
  authDomain: "today-app-7ccf0.firebaseapp.com",
  databaseURL: "https://today-app-7ccf0.firebaseio.com",
  projectId: "today-app-7ccf0",
  storageBucket: "",
  messagingSenderId: "48571227092"
};

firebase.initializeApp(config);

export default {
  data() {
    return {
      isSignup: false,
      user: Object,
      githubCredential: String
    };
  },
  components: { IconGithub },
  methods: {
    toggleSignup() {
      this.isSignup = !this.isSignup;
    },
    redirectSignin() {
      const provider = new firebase.auth.GithubAuthProvider();
      provider.addScope("repo");
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          // this.user = result;
          console.log();
          // const username = result.profile.login;
          const githubUser = {
            username: result.additionalUserInfo.profile.login,
            credential: result.credential.accessToken
          };
          localStorage.setItem("githubCredentials", JSON.stringify(githubUser));
          this.$router.push("app");
          // console.log(githubUser);
          // localStorage.setItem("projects", JSON.stringify(this.projects));
          // console.log(this.$root);
        });
    }
  }
};
</script>

<style lang="scss">
.login {
  display: grid;
  > form {
    display: grid;
    grid-gap: 25px;
  }
  a {
    text-decoration: none;
    color: $primary;
  }
}
.icon--github {
  @include icon-size(24px);

  fill: $mono-100;
}
.input--login {
  all: unset;
  position: relative;
  position: relative;
  padding: 5px 0;
  transition: border 0.2s ease;
  transition: opacity 0.2s ease, height 0.2s ease;
  color: $mono-100;
  border-bottom: 1px solid $mono-100;
  background: $mono-0;
}
.button--submit {
  all: unset;
  font-weight: 500;
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  align-items: center;
  padding: 10px 25px;
  cursor: pointer;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: $mono-100;
  border: 1px solid $mono-100;

  justify-self: start;
  &:hover {
    opacity: 0.8;
  }
}
</style>
